
/* ===== VELANTIS_APPLE_SELECTS — selects estilo Apple (finder + catálogo) ===== */
(function(){
  var IDS=['xfFam','xfNote','catFam','catNote'];
  var CAE='<svg class="asel-cae" viewBox="0 0 24 24"><path d="M6 9l6 6 6-6"/></svg>';
  var CHK='<svg class="asel-chk" viewBox="0 0 24 24"><path d="M5 12l5 5 9-10"/></svg>';
  function enhance(sel){
    if(!sel || sel.dataset.aselDone) return; sel.dataset.aselDone='1';
    var wrap=document.createElement('div'); wrap.className='asel';
    sel.parentNode.insertBefore(wrap, sel); wrap.appendChild(sel);
    var trigger=document.createElement('button'); trigger.type='button'; trigger.className='asel-trigger';
    var lbl=document.createElement('span'); lbl.className='asel-lbl'; trigger.appendChild(lbl);
    trigger.insertAdjacentHTML('beforeend', CAE);
    var panel=document.createElement('div'); panel.className='asel-panel'; panel.setAttribute('role','listbox');
    wrap.appendChild(trigger);
    document.body.appendChild(panel); // fuera del árbol del finder (evita opacity/overflow heredados)

    function syncLabel(){ var o=sel.options[sel.selectedIndex]; lbl.textContent=o?o.textContent:''; }
    function syncSel(){ [].forEach.call(panel.children,function(c){ c.classList.toggle('sel', c.dataset.val===sel.value); }); }
    function build(){
      panel.innerHTML='';
      [].forEach.call(sel.options,function(o){
        var it=document.createElement('div'); it.className='asel-opt'+(o.selected?' sel':''); it.setAttribute('role','option'); it.dataset.val=o.value;
        var s=document.createElement('span'); s.textContent=o.textContent; it.appendChild(s);
        it.insertAdjacentHTML('beforeend', CHK);
        it.addEventListener('click',function(e){ e.stopPropagation(); choose(o.value); });
        panel.appendChild(it);
      });
      syncLabel();
    }
    function choose(v){ sel.value=v; sel.dispatchEvent(new Event('change',{bubbles:true})); syncSel(); syncLabel(); close(); }
    function place(){ var r=trigger.getBoundingClientRect();
      panel.style.top=(r.bottom+8)+'px'; panel.style.left=r.left+'px'; panel.style.minWidth=r.width+'px';
      // si se sale por la derecha, alinear a la derecha del trigger
      var pw=Math.max(r.width, panel.offsetWidth||r.width);
      if(r.left+pw>window.innerWidth-12){ panel.style.left=Math.max(12,(r.right-pw))+'px'; }
    }
    function open(){ closeAll(); panel.classList.add('open'); wrap.classList.add('open'); place(); }
    function close(){ panel.classList.remove('open'); wrap.classList.remove('open'); }
    trigger.addEventListener('click',function(e){ e.stopPropagation(); wrap.classList.contains('open')?close():open(); });
    panel.addEventListener('click',function(e){ e.stopPropagation(); });
    sel.addEventListener('change',function(){ syncSel(); syncLabel(); });
    wrap._aselReposition=function(){ if(wrap.classList.contains('open')) place(); };
    build();
  }
  function closeAll(){ [].forEach.call(document.querySelectorAll('.asel.open, .asel-panel.open'),function(el){ el.classList.remove('open'); }); }
  document.addEventListener('click',function(e){ if(e.target.closest('.asel')||e.target.closest('.asel-panel')) return; closeAll(); });
  document.addEventListener('keydown',function(e){ if(e.key==='Escape') closeAll(); });
  window.addEventListener('scroll',function(){ [].forEach.call(document.querySelectorAll('.asel.open'),function(w){ w._aselReposition && w._aselReposition(); }); }, true);
  window.addEventListener('resize',closeAll);
  function boot(){ IDS.forEach(function(id){ enhance(document.getElementById(id)); }); }
  if(document.readyState!=='loading') boot(); else document.addEventListener('DOMContentLoaded',boot);
})();
